import axios from "axios";
import { API_AUTH_SERVICE_BACKEND, isLocalOrStagingEnv } from "src/config";

const refreshAuthToken = async (firebaseToken) => {
  try {
    // Send Firebase token with 'token' field - backend will detect it's a Firebase token
    const requestBody = {
      token: firebaseToken
    };
    const jwtResponse = await axios.post(
      `${API_AUTH_SERVICE_BACKEND}/token`,
      requestBody,
    );

    const jwtToken = jwtResponse?.data?.token;

    // Check if token is present in response
    if (!jwtToken) {
      throw new Error("No token received from authentication service");
    }

    // On localhost, update token in sessionStorage for Authorization header injection
    if (isLocalOrStagingEnv()) {
      window.sessionStorage.setItem('b2b_at_local', jwtToken);
    }

    // Backend sets httpOnly cookie via Set-Cookie header automatically
    //console.log("Backend JWT response:", jwtResponse.data);
    return jwtResponse.data;
  } catch (err) {
    console.error("Backend token API failed:", err);
    throw err;
  }
}
export default refreshAuthToken;